import { Box, Typography, useTheme } from "@mui/material";
import { logoDesktop } from '@frontend/assets';

export const Home = () => {
  const { palette, spacing } = useTheme();

  return (
    <Box
      height="100%"
      bgcolor="primary.main"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Box width="20%" textAlign="right" position="relative">
      <img width="100%" src={logoDesktop} />
      <Typography variant="h5" color={palette.common.white} sx={{ position: 'relative', right: `-${spacing(5)}` }}>corporativo</Typography>
      </Box>

    </Box>
  )
}
